<template>
  <div>
    <vs-col style="padding: 5px; margin-top: 10px">
      <vs-row>Configure new fields:</vs-row>
    </vs-col>
    <Field
      v-for="(field, index) in newFields"
      :key="index"
      :fieldInitState="field"
      @removeField="index => removeField(index)"
      @newFieldInfoCompleted="params => updateNewFieldInfo(params)"
    />
    <vs-row>
      <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding: 5px">
        <vs-button
          color="primary"
          type="filled"
          icon="add"
          size="small"
          @click="addField"
        >
        </vs-button>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import Field from "./Field";
import { mapActions } from "vuex";
import lastFulfilled from './mixins/lastFulfilled';

export default {
  name: "NewFields",
  components: {
    Field
  },
  mixins: [lastFulfilled],
  computed: {
    newFields () {
      return this.$store.state.customFields.newFields;
    }
  },
  methods: {
    ...mapActions('customFields', ['addNewField', 'removeField', 'updateNewFieldInfo']),
    addField () {
      if (this.lastFulfilled(this.newFields)) {
        this.addNewField();
      }
    }
  },
};
</script>